export default "__VITE_ASSET__96d31f88__"